import React, { useEffect, useRef } from 'react';
import widgetRender from './bei-light';

function test2(data, action) {
  // json parametres de la viz
  const widgetProperties_US342 = {
    generalProperties: {
      chartType: 'barchart', // barchart, pie, linechart
      orientation: 'horizontal', // horizontal, vertical (for XY axis chart)
      direction: 'standard', // standard, opposite
      margin: { top: 100, right: 20, bottom: 100, left: 80 },
      size: { width: '100%', height: '100%' },
      minSize: { width: 420, height: 330 },
      minPlotSize: { width: 100, height: 100 },
      activeClipPath: false,
      errorMsg: 'lorem ipsum'
    },
    detailProperties: {
      dataAggregation: false,
      dimensionFields: ['investor'],
      dimensionFieldsDatatype: ['text'],
      dimensionFieldsLabel: ['investor'],
      dimensionFieldsFormat: null,
      dimensionFieldsCustomSort: [null],
      dimensionFieldsSortOrder: [null],
      calculationFields: ['pct'],
      calculationFieldsLabel: ['pct'],
      calculationFieldsDatatype: ['number'],
      calculationFieldsFormat: ['.4'],
      calculationFieldsAdjustPct: false,
      styles: {
        themeScheme: 'beiLightTheme',
        colors: {
          defaultColor: '#002380',
          defaultStrokeColor: '#002380',
          defaultFillColor: '#002380',
          dimensionField: ['serieIndex'],
          dimensionFieldSortOrder: null,
          dimensionFieldCustomOrder: null,
          dimensionScaleMode: ['categorical'], // categorical, continous
          scaleType: ['scaleOrdinal'], // scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          interpolator: null,
          scheme: ['#002380', '#1E91A6', '#75C7C3', '#A3E3C0', '#CFFCD1'],
          schemeType: 'colorArray' // colorArray, colorGradientArray
        },
        textures: {
          active: false,
          defaultTexture: ''
        }
      },
      XYChart: {
        includeOrigin: true, // used for barchart / linechart
        linearGridline: true,
        categoricalGridline: false,
        linearAxis: false,
        linearAxisLine: false,
        linearAxisLabel: true,
        linearAxisLabelFormat: '.0%',
        linearAxisTick: false,
        linearAxisMinMaxExtendFactor: [1, 1.5],
        linearAxisTicksNumber: 3,
        categoricalAxis: true,
        categoricalAxisLabel: true,
        categoricalAxisTick: false,
        categoricalAxisLabelFormat: null,
        categoricalAxisLabelVPadding: 10,
        categoricalAxisLabelTextWrapWidth: 80,
        categoricalAxisLabelTextWrapLineHeight: 1.2,
        categoricalAxisLabelTextAnchor: 'middle',
        barPadding: 0.4, // value between 0 and 1
        barRadius: 0, // value in px
        barRadiusPosition: 'all', // all, top, bottom
        barGroupPadding: 0.7, // value between 0 and 1
        barBandwithReduction: 0
      },
      axis: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '200',
        color: '#979797',
        altColor: '#000000',
        labelColor: '#65676a',
        tickSize: 0,
        padding: 0,
        lineWidth: 0
      },
      gridline: {
        padding: -10,
        showExtend: true,
        dashArray: '10 10',
        width: 0.5,
        color: '#979797',
        altColor: '#000000',
        opacity: 0.8
      },
      title: {
        text: null,
        hPosition: 'left',
        vPosition: 'top',
        hPadding: 20,
        vPadding: 10,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#535353',
        fontSize: '18px',
        fontWeight: '300',
        textAnchor: 'middle',
        SVG:
          "<text style='text-anchor:start'><tspan dy='0.7em'>IMPLIED WACC DERIVED FROM CURRENT</tspan><tspan x='0' dy='1.4em'>SHARE PRICE AND BASED ON CONSENSUS</tspan></text>"
      },
      label: {
        visible: true,
        color: '#000000',
        vPadding: -5,
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '300',
        variableFormat: {
          pct: { datatype: 'number', formatIn: '.3', formatOut: '.1%' }
        }
      },
      tooltip: {
        active: true,
        hPosition: 'mouse', // shape, mouse, fixe
        vPosition: 'mouse',
        hRelPosition: 'center',
        vRelPosition: 'up',
        // 'column' : ['cout','etp_contractuel','etp_ecart'],
        // 'columnSuffix' : [' ETP absence',' ETP contractuel',' ETP par rapport au indirect'],
        lineSeparator: true,
        fontFamily: 'Montserrat',
        padding: 0,
        color: '#535353', // '#FFFFFF'
        fontSize: '15px',
        fontWeight: '400',
        textAnchor: 'start',
        backgroundColor: '#ffffff', // '#535353',
        SVG:
          "<g><g><line x1='14' x2='14' y1='10' y2='70' style='stroke : #002380;stroke-width: 2' /></g><text x='10' y='14' dy='0.7em'><tspan x='25' y='20'>[investor]</tspan><tspan x='25' y='62'>Value : [pct]</tspan></text></g>",
        variableFormat: {
          pct: { datatype: 'number', formatIn: '.4', formatOut: '.2%' }
        },
        tooltipSpecificFn: null
      },
      animation: {
        active: true,
        duration: 600,
        delay: 0,
        incrementalDelay: 0,
        ease: 'easeCubic' // default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      events: {
        mouseover: true,
        click: false
      }
    },
    contextualProperties: {
      tagId: 'ChartImpliedWacc',
      dataIn: data,
      dataOut: null,
      d3viz: {
        dom: { viz: null, gridline: null, plot: null, axis: null, title: null },
        axis: {
          x: null,
          y: null,
          x2: null,
          y2: null,
          color: null,
          texture: null
        },
        barchart: { bandwidth: null }
      }
    }
  };

  widgetRender(widgetProperties_US342, action);
}

const ChartImpliedWacc = ({ data, loading, error }) => {
  const d3svg = useRef(false);

  /*   useEffect(() => {
  }, [loading]); */

  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        test2(data, 'init');
      }
    } else d3svg.current = true;
  }, [data]);

  return (
    <>
      <div
        ref={d3svg}
        className="bar-chart-container"
        id="ChartImpliedWacc"
        role="img"
        style={{ width: '100%', height: '350px' }}>
        {loading && <h4>Loading...</h4>}
        {error && <h4>{error}</h4>}
      </div>
    </>
  );
};

export default ChartImpliedWacc;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
